<template>
	<el-date-picker
		ref="input"
		class="input-sigarus-time-select"
      	v-model="model"
		v-bind="getBind()"
		:clearable="false"
      	type="datetime"
		value-format="dd/MM/yyyy HH:mm:ss"
		format="dd/MM/yyyy HH:mm:ss"
	  	@change="$emit('save')"
		@focus="$emit('focus')"
		@blur="$emit('blur')">
    </el-date-picker>
</template>

<script>
	import moment from 'moment'
	export default {
		name: 'InputSigarusDateTimeSelect',
		props: {
			value: {
				default: ''
			}
		},
		computed: {

			model: {

				get () { 
					return this.value || ''
				},

				set (val) {
					this.$emit('input', val)
				}
			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },
			
			getBind () {
				delete this.$attrs.type

				return {...this.$attrs, ...this.$props}
			}
		}
	}
</script>
